import * as types from '@/store/types';
import { removeNamespaces } from '@/helpers/utils';

const localTypes = removeNamespaces(types);

export default {
  [localTypes.QUEUES_SET](state, payload) {
    state.queues = payload;
  },
  [localTypes.QUEUES_TAGS_SET](state, payload) {
    state.tags = payload;
  },
};
